const initMediaKit = () => {
	const mediaKit = document.querySelector('.media-kit-single');

	if ( !mediaKit ) return;

	mediaKit.querySelectorAll('.media-gallery-toggle')
		.forEach((toggle) => {
			toggle.addEventListener('click', function(e) {
				const thisPressRelease = this.closest('.press-release');
				const thisIsOpened = thisPressRelease.classList.contains('opened');
				mediaKit.querySelectorAll('.press-release.opened')
					.forEach((pressRelease) => {
						pressRelease.classList.remove('opened');
					});
				if ( !thisIsOpened ) {
					thisPressRelease.classList.add('opened');
				}
			});
			
		});
}

document.addEventListener("DOMContentLoaded", initMediaKit);